import LoadingIndicator from "../../misc/LoadingIndicator";

const TableLoading = () => {
  return (
    <div
      role="status"
      aria-label="Se încarcă tabelul"
      className="absolute inset-0 z-10 flex justify-center bg-surface-subtle/50">
      <div className="mt-[100px] h-fit w-fit rounded-control bg-white p-5 text-center text-base font-bold text-muted-dark shadow-card">
        <LoadingIndicator size={50} color="primary" />
      </div>
    </div>
  );
};

export { TableLoading };
